// extracted by mini-css-extract-plugin
export default {"sucessContainer":"orderSucess_sucessContainer__Xag30","sucessHeading":"orderSucess_sucessHeading__yCdQN","sucessGif":"orderSucess_sucessGif__TEnPT"};